import React from "react";
import FiberNewRoundedIcon from "@mui/icons-material/FiberNewRounded";
import { Tooltip } from "@mui/material";
import { isAfter, subMonths } from "date-fns";

const NewCustomerIcon = (props) => {
  const { createdAt } = props;
  const isNewCustomer = createdAt
    ? isAfter(new Date(createdAt), subMonths(new Date(), 2))
    : false;
  if (!isNewCustomer) {
    return null;
  }
  return (
    <Tooltip title="New Customer (Created within 2 months)">
      <FiberNewRoundedIcon
        sx={{ marginLeft: "5px", color: "#4caf50", fontSize: "1.5rem" }}
      />
    </Tooltip>
  );
};

export default NewCustomerIcon;
